import { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useIdleTimer } from 'react-idle-timer';

import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import CustomModal from 'src/components/custom_components/CustomModal/CustomModal';

import useUiTranslation from 'src/hooks/useUiTranslation';

const timeout = parseInt(import.meta.env.VITE_IDLE_TIMER_TIMEOUT);
const promptBeforeIdle = parseInt(
  import.meta.env.VITE_IDLE_TIMER_PROMPT_BEFORE_IDLE,
);

export default function CustomIdleTimer() {
  const [remaining, setRemaining] = useState<number>(timeout);
  const [open, setOpen] = useState<boolean>(false);

  const { logOut } = useRemoteBoundStore();

  const onIdle = () => {
    setOpen(false);
    logOut();
  };

  const onActive = () => {
    setOpen(false);
  };

  const onPrompt = () => {
    setOpen(true);
  };

  const { getRemainingTime, activate } = useIdleTimer({
    onIdle,
    onActive,
    onPrompt,
    timeout,
    promptBeforeIdle,
    throttle: 500,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000));
    }, 500);

    return () => {
      clearInterval(interval);
    };
  });

  const handleStillHere = () => {
    activate();
  };

  const { tPages } = useUiTranslation();
  return (
    <CustomModal show={open}>
      <Modal.Header>
        <Modal.Title>{tPages('loginLogout.idleTimer.title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {tPages('loginLogout.idleTimer.desc', { remaining })}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleStillHere}>
          {tPages('loginLogout.idleTimer.keepMeLoggedIn')}
        </Button>
      </Modal.Footer>
    </CustomModal>
  );
}
